<template>
  <div>
    <div class="banner-box">
      <el-carousel :interval="4000" arrow="hover" height="1024px" v-if="advBannerlist!=null">
        <el-carousel-item v-for="(item,index) in advBannerlist" :key="index">
          <el-image fit="cover" :src="item.url"/>
        </el-carousel-item>
      </el-carousel>
      <el-carousel :interval="4000" arrow="hover" height="1024px" v-else>
        <el-carousel-item>
          <el-image fit="cover" src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082512134423.jpg"/>
        </el-carousel-item>
        <el-carousel-item>
          <el-image fit="cover" src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082512142541.jpg"/>
        </el-carousel-item>
        <el-carousel-item>
          <el-image fit="cover" src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082512145240.jpg"/>
        </el-carousel-item>
        <el-carousel-item>
          <el-image fit="cover" src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/202108251215164.jpg"/>
        </el-carousel-item>
        <el-carousel-item>
          <el-image fit="cover" src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082512155041.jpg"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="intro-features clearfix">
      <div class="box">
        <div class="features-p">
          <div class="custom-box-1" style="margin-top: 130px">
            <h1 class="text-1">
              <span class="custom-font-color-1">“ </span>
              <span class="bg-2" style="color: rgb(255, 255, 255); padding: 5px 20px;">深耕天然橡胶产业链的综合企业</span>
            </h1>
            <h1 class="text-2">
              <span class="bg-3" style="color: rgb(255, 255, 255); padding: 5px 20px;">绿色橡胶，安心手套</span>
            </h1>
            <h1 class="text-2">
              <span class="bg-3" style="color: rgb(255, 255, 255); padding: 5px 20px;">诗董与您共创品质生活</span>
              <span class="custom-font-color-2"> ” </span>
            </h1>
            <h1 class="text-3">
              诗董集团（SriTrangGroup）1987 年成立于泰国合艾，是深耕天然橡胶产业链的综合企业，于泰国和新加坡证券交易所双边上市。公司主营业务覆盖橡胶园种植、初级橡胶原料加工、终端橡胶产品制造、国际橡胶贸易、配套及物流服务等，实现深度产业链一体化。
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div class="intro-features2 clearfix">
      <div class="box">
        <div class="start">
          <div class="custom-box-1">
            <h1 class="text-1">
              <span class="custom-font-color-1">“ </span>
              <span class="bg-2" style="color: rgb(255, 255, 255); padding: 5px 20px;">诗董</span>
            </h1>
            <h1 class="text-2">
              <span class="custom-font-color-2">产能布局</span>
              <span class="custom-font-color-2"> ” </span>
            </h1>
            <h1 class="text-3">诗董深耕天然橡胶行业与泰国检查手套行业，旗下拥有35家橡胶工厂和6家手套工厂业务网络覆盖全球。</h1>
          </div>
        </div>
        <div class="end">
          <div class="custom-box-1">
            <h1 class="text-1">
              <span class="custom-font-color-1" style="font-size: 0.6em;">成立于</span>
              <span>1987年</span>
              <span class="custom-font-color-1" style="margin-left: 30px; font-size: 0.6em;">分支机构</span>
              <span>29家</span>
              <span class="custom-font-color-1" style="margin-left: 30px; font-size: 0.6em;">遍布全球</span>
              <span>9个国家</span>
            </h1>
            <div class="custom-inbox-1">
              <div class="item">
                <div class="bb-item">
                  <h1>橡胶种植园</h1>
                  <h1>19个省</h1>
                  <h1 class="custom-bg-color-2"
                      style="border-radius: 0px 0px 6px 6px; margin-bottom: 0px; height: 50px; line-height: 50px">
                    面积7,200公顷
                  </h1>
                </div>
              </div>
              <div class="item">
                <div class="bb-item">
                  <h1>标胶工厂</h1>
                  <h1>24间</h1>
                  <h1 class="custom-bg-color-2"
                      style="border-radius: 0px 0px 6px 6px; margin-bottom: 0px; height: 50px; line-height: 50px">
                    年产能241万吨</h1>
                </div>
              </div>

              <div class="item">
                <div class="bb-item">
                  <h1>烟片工厂</h1>
                  <h1>3间</h1>
                  <h1 class="custom-bg-color-2"
                      style="border-radius: 0px 0px 6px 6px; margin-bottom: 0px; height: 50px; line-height: 50px">
                    年产能18万吨
                  </h1>
                </div>
              </div>

              <div class="item">
                <div class="bb-item">
                  <h1>乳胶工厂</h1>
                  <h1>8间</h1>
                  <h1 class="custom-bg-color-2"
                      style="border-radius: 0px 0px 6px 6px; margin-bottom: 0px; height: 50px; line-height: 50px">
                    年产能58.8万吨</h1>
                </div>
              </div>

              <div class="item">
                <div class="bb-item">
                  <h1>手套工厂</h1>
                  <h1>6间</h1>
                  <h1 class="custom-bg-color-2"
                      style="border-radius: 0px 0px 6px 6px; margin-bottom: 0px; height: 50px; line-height: 50px">
                    年产能553亿</h1>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="intro-features3 clearfix">
      <div class="box">
        <div class="custom-box-1">
          <h1 class="text-1">
            <span class="custom-font-color-1">“ </span>
            <span class="bg-2" style="color: rgb(255, 255, 255); padding: 5px 20px;">诗董</span>
          </h1>
          <h1 class="text-2">
            <span class="bg-3" style="color: rgb(255, 255, 255); padding: 5px 20px;">产品系列</span>
            <span class="custom-font-color-2"> ” </span>
          </h1>
        </div>
        <div class="list">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="item">
                <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/images/1.956f35c0.jpg"></el-image>
                <div class="name">标胶</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/images/2.cd666eb2.jpg"></el-image>
                <div class="name">乳胶</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/images/3.2f23994c.jpg"></el-image>
                <div class="name">烟片</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/images/4.5fbe7f83.jpg"></el-image>
                <div class="name">乳胶有粉手套</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/images/5.26f3b662.jpg"></el-image>
                <div class="name">乳胶无粉手套</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/images/6.f7d9c70c.jpg"></el-image>
                <div class="name">丁腈手套</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="intro-features4 clearfix">
      <div class="box">
        <el-row>
          <el-col :span="12">
            <div class="v-item">
              <div class="custom-box-1" style="margin-top: 60px; height: 150px;">
                <h1 class="text-1">
                  <span class="custom-font-color-1">“ </span>
                  <span class="bg-2" style="color: rgb(255, 255, 255); padding: 5px 20px;">诗董</span></h1>
                <h1 class="text-2">
                  <span class="bg-3" style="color: rgb(255, 255, 255); padding: 5px 20px;">集团视频</span>
                  <span class="custom-font-color-2"> ” </span>
                </h1>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="v-item">
              <div class=" custom-bg-tv">
                <div class="video-box">

                  <video poster="/img/STA.jpg" loop="loop" muted="muted" controls="controls"
                         style="width: 100%; height: 100%;">
                    <source src="https://sritrang.oss-cn-shanghai.aliyuncs.com/video/STA%20Co.%20cn.mp4"
                            type="video/mp4">
                    您的浏览器不支持视频播放，请更新到最新版本
                  </video>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="intro-features5 clearfix">
      <el-row :gutter="20">
        <el-col :span="16">
          <div class="title">最新公司新闻</div>
          <div class="list" v-if="articles!=null">
            <el-row :gutter="20">
              <el-col :span="12" v-for="(item,index) in articles" :key="index">
                <div class="a-box">
                  <div class="a-item">
                    <router-link :to="{path:'/news-detail',query:{id:item.id}}" class="item-permalink">
                      <i class="el-icon-link"></i>
                    </router-link>
                    <router-link :to="{path:'/news-detail',query:{id:item.id}}" class="item-preview">
                      <i class="el-icon-search"></i>
                    </router-link>
                    <div class="img">
                      <el-image :src="item.coverUrl"></el-image>
                    </div>
                  </div>
                  <div class="a-title">
                    <router-link :to="{path:'/news-detail',query:{id:item.id}}" class="item-permalink">
                      <div class="time">{{ item.strShowTime }}</div>
                      {{ item.title }}
                    </router-link>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="more">
            <router-link to="/news-detail" style="color: white">更多新闻</router-link>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="title">最新展会</div>
          <div style=" margin-right: 15px">
            <el-carousel :interval="5000" arrow="hover" height="545px" v-if="advHZList!=null">
              <el-carousel-item v-for="(item,index) in advHZList" :key="index">
                <el-image fit="fill"
                          style="height: 100%; width: 100%"
                          :src="item.url"/>
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

import {getIndex} from '@/api/api'

export default {
  name: "Index",
  data() {
    return {
      advBannerlist: null,
      advHZList: null,
      articles: null
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      getIndex().then((res) => {
        this.advBannerlist = res.data.advBannerlist;
        this.advHZList = res.data.advHZList;
        this.articles = res.data.articles;
      });
    }
  }
}
</script>

<style scoped>
@import url("Index.css?v=1");
</style>
